import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({ endPoint: 'DocumentType/All', method: 'GET', body: null, token: token })
}
